import React, { useState } from "react";
import style from "../../../css/Distribuidora.module.css";
import fondo from "../../../assets/img/nuevosBanners/Distribuidor-Perfil.jpg";
import image27 from "../../../assets/img/image 27.png";
import { PreguntasDespliegue } from "../../../homeComun/components/Footer/PreguntasDespliegue";
import pdf from "../../../../src/assets/img/Banner/Información-Formasdepago.pdf";
import { Link } from "react-router-dom";
import recuersoUno from "../../../assets/img/guiaDistribuidora/Recurso_1.svg";
import recuersoDos from "../../../assets/img/guiaDistribuidora/Recurso_2.svg";
import recuersoTres from "../../../assets/img/guiaDistribuidora/Recurso_3.svg";
import recuersoCuatro from "../../../assets/img/guiaDistribuidora/Recurso_4.svg";
import recuersoCinco from "../../../assets/img/guiaDistribuidora/Recurso_5.svg";
import recuersoSeis from "../../../assets/img/guiaDistribuidora/Recurso_6.svg";
import { DynamicSlider } from "../../../homeComun/components/DynamicSlider";

const firstSteps = [
  {
    id: "1",
    step: "Comparte catálogo con clientes potenciales",
    image: recuersoUno,
  },
  {
    id: "2",
    step: "Recomienda productos según la necesidad de tus clientes",
    image: recuersoDos,
  },
  {
    id: "3",
    step: "Pasa pedidos en fecha",
    image: recuersoTres,
    stepMore:
      "Recibe premios en todas tus campañas, por compras mensuales de $100 o más durante dos campañas seguidas",
  },
  {
    id: "4",
    step: "Recibe pedido en reparto",
    image: recuersoCuatro,
  },
  {
    id: "5",
    step: "Entrega y cobra el producto a sus clientes",
    image: recuersoCinco,
  },
  {
    id: "6",
    step: "Conoce los productos y realiza demostraciones para generar ventas",
    image: recuersoSeis,
  },
];

export const FoooterDistribuidora = () => {
  const [preguntaDesplegada, setPreguntaDesplegada] = useState(null);

  const cambiarDespliegue = (index) => {
    if (preguntaDesplegada === index) {
      setPreguntaDesplegada(null); // Si se hace clic en la pregunta ya desplegada, ciérrala
    } else {
      setPreguntaDesplegada(index); // De lo contrario, establece la nueva pregunta desplegada
    }
  };
  const dataFaq = [
    {
      pregunta: "¿CÓMO SÉ CUÁL ES MI CÓDIGO DE DISTRIBUIDOR?",
      respuesta:
        "Tu código de distribuidor lo puedes encontrar en tu factura y es el que te servirá para cancelar en Tigo Money y Akí Pago. ",
    },
    {
      pregunta: "¿CÓMO PUEDO AUMENTAR MI LÍMITE DE CRÉDITO COMO DISTRIBUIDOR?",
      respuesta:
        "Que tus compras sean superiores al límite de crédito en los últimos 3 meses.\nPresentar comprobantes de créditos en otros lugares, constancia de salario, boleta de pago o remesas de los últimos 3 meses.",
    },
    {
      pregunta: "¿CÓMO GANO MI PREMIO POR CAMPAÑA COMO DISTRIBUIDOR?",
      respuesta:
        "Haz tu pedido por dos meses consecutivos con la meta establecida para cada campaña a precio catálogo (Regularmente es entre $100 y $150).\nEl monto de la meta para el premio no incluye herramientas de ventas, productos que no están en el catálogo de la campaña en curso y liquidaciones de Vogue Plus.\nSe descontará al monto del pedido las devoluciones y/o cambios pendientes.\nPara información más exacta consulta tu Vogue Plus de la campaña en curso.",
    },
    {
      pregunta: "¿CUÁL ES EL COSTO DE ENVÍO POR MI PAQUETE?",
      respuesta:
        "Si tu envío es en San Salvador (incluyendo Antiguo Cuscatlan, Nuevo Cuscatlan y Zaragoza) es de $2.75 por pedido.\nSi tu envío es departamental es de $3.50 por pedido",
    },
  ];
  return (
    <>
    <DynamicSlider section="Dist-Distribuidor Vogue" subSection="Guía del Distribuidor" />
      <h2 className={style.conoce}>
        Proceso de ventas <br />
        <span>de un distribuidor</span>
      </h2>
      <div className={style.contenedorBeneficioss}>
        {firstSteps.length > 0 &&
          firstSteps?.map(({ id, step, image, stepMore }) => (
            <div className={style.beneficios} key={id}>
              <div className={style.circulo}>
                <img src={image} alt={`Imagen ilustrativa del paso ${step}`} />
              </div>
              <div className={style.descripcion}>
                <div className={style.textDescription}>
                  <p className={style.parrafo}>{id}.</p>
                  <p className={style.parrafo}>{step}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
      <span className={style.moreDescriptionTwo}>Recibe premios en todas tus campañas, por compras mensuales de $100 o más durante dos campañas seguidas</span>
      <img className={style.imagenDis} src={image27} alt="" />
      <div className={style.contenedorRealizarPagos}>
        <h2 className={style.tituloPago}>¿Cómo puedes realizar tus pagos?</h2>
        <div className={style.contenedorGeneral}>
          <div className={style.contenedorcirculo}>
            <div className={style.circulo}>
              <div className={style.oficinas}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="63"
                  height="63"
                  viewBox="0 0 63 63"
                  fill="none"
                >
                  <path
                    d="M38.8194 54.6703V40.7003C38.8194 39.2514 38.8194 38.5269 38.5375 37.9735C38.2894 37.4868 37.8937 37.091 37.4069 36.843C36.8535 36.561 36.129 36.561 34.6802 36.561H27.4364C25.9876 36.561 25.2631 36.561 24.7097 36.843C24.2229 37.091 23.8272 37.4868 23.5791 37.9735C23.2972 38.5269 23.2972 39.2514 23.2972 40.7003V54.6703M49.1676 54.6703V16.3821C49.1676 13.4843 49.1676 12.0354 48.6037 10.9286C48.1076 9.95505 47.3161 9.16351 46.3425 8.66746C45.2357 8.10352 43.7868 8.10352 40.8891 8.10352H21.2275C18.3298 8.10352 16.8809 8.10352 15.7741 8.66746C14.8005 9.16351 14.009 9.95505 13.5129 10.9286C12.949 12.0354 12.949 13.4843 12.949 16.3821V54.6703M54.3417 54.6703H7.7749M24.5907 21.0387H24.6166M37.5259 21.0387H37.5518M25.8842 21.0387C25.8842 21.7531 25.3051 22.3323 24.5907 22.3323C23.8763 22.3323 23.2972 21.7531 23.2972 21.0387C23.2972 20.3243 23.8763 19.7452 24.5907 19.7452C25.3051 19.7452 25.8842 20.3243 25.8842 21.0387ZM38.8194 21.0387C38.8194 21.7531 38.2403 22.3323 37.5259 22.3323C36.8115 22.3323 36.2324 21.7531 36.2324 21.0387C36.2324 20.3243 36.8115 19.7452 37.5259 19.7452C38.2403 19.7452 38.8194 20.3243 38.8194 21.0387Z"
                    stroke="white"
                    strokeWidth="5.17409"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            <h2 className={style.tituloOficina}>Oficinas</h2>
          </div>
          <div className={style.contenedorcirculo}>
            <div className={style.circulo}>
              <div className={style.oficinas}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="55"
                  height="56"
                  viewBox="0 0 55 56"
                  fill="none"
                >
                  <path
                    d="M15.1334 15.6334H15.1561M40.1063 15.6334H40.129M15.1334 40.6063H15.1561M29.8901 30.3901H29.9128M40.1063 40.6063H40.129M38.9712 48.5522H48.0522V39.4712M32.1604 38.336V48.5522M48.0522 32.6604H37.836M35.7928 23.5793H44.4198C45.6913 23.5793 46.327 23.5793 46.8126 23.3319C47.2398 23.1142 47.5871 22.7669 47.8048 22.3398C48.0522 21.8541 48.0522 21.2184 48.0522 19.9469V11.3199C48.0522 10.0485 48.0522 9.41272 47.8048 8.92708C47.5871 8.49991 47.2398 8.1526 46.8126 7.93494C46.327 7.6875 45.6913 7.6875 44.4198 7.6875H35.7928C34.5213 7.6875 33.8856 7.6875 33.4 7.93494C32.9728 8.1526 32.6255 8.49991 32.4078 8.92708C32.1604 9.41272 32.1604 10.0485 32.1604 11.3199V19.9469C32.1604 21.2184 32.1604 21.8541 32.4078 22.3398C32.6255 22.7669 32.9728 23.1142 33.4 23.3319C33.8856 23.5793 34.5213 23.5793 35.7928 23.5793ZM10.8199 23.5793H19.4469C20.7184 23.5793 21.3541 23.5793 21.8398 23.3319C22.2669 23.1142 22.6142 22.7669 22.8319 22.3398C23.0793 21.8541 23.0793 21.2184 23.0793 19.9469V11.3199C23.0793 10.0485 23.0793 9.41272 22.8319 8.92708C22.6142 8.49991 22.2669 8.1526 21.8398 7.93494C21.3541 7.6875 20.7184 7.6875 19.4469 7.6875H10.8199C9.54845 7.6875 8.91272 7.6875 8.42708 7.93494C7.99991 8.1526 7.6526 8.49991 7.43494 8.92708C7.1875 9.41272 7.1875 10.0485 7.1875 11.3199V19.9469C7.1875 21.2184 7.1875 21.8541 7.43494 22.3398C7.6526 22.7669 7.99991 23.1142 8.42708 23.3319C8.91272 23.5793 9.54845 23.5793 10.8199 23.5793ZM10.8199 48.5522H19.4469C20.7184 48.5522 21.3541 48.5522 21.8398 48.3048C22.2669 48.0871 22.6142 47.7398 22.8319 47.3126C23.0793 46.827 23.0793 46.1913 23.0793 44.9198V36.2928C23.0793 35.0213 23.0793 34.3856 22.8319 33.9C22.6142 33.4728 22.2669 33.1255 21.8398 32.9078C21.3541 32.6604 20.7184 32.6604 19.4469 32.6604H10.8199C9.54845 32.6604 8.91272 32.6604 8.42708 32.9078C7.99991 33.1255 7.6526 33.4728 7.43494 33.9C7.1875 34.3856 7.1875 35.0213 7.1875 36.2928V44.9198C7.1875 46.1913 7.1875 46.827 7.43494 47.3126C7.6526 47.7398 7.99991 48.0871 8.42708 48.3048C8.91272 48.5522 9.54845 48.5522 10.8199 48.5522Z"
                    stroke="white"
                    strokeWidth="4.54053"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            <h2 className={style.tituloOficina}>Colectores</h2>
          </div>
          <div className={style.contenedorcirculo}>
            <div className={style.circulo}>
              <div className={style.oficinas}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="66"
                  height="66"
                  viewBox="0 0 66 66"
                  fill="none"
                >
                  <path
                    d="M16.5477 30.2766V41.2584M49.4929 24.7858V35.7675M46.7474 11.0586C53.4702 11.0586 57.1063 12.0875 58.9155 12.8855C59.1565 12.9918 59.2769 13.0449 59.6246 13.3768C59.833 13.5757 60.2135 14.1593 60.3113 14.4302C60.4746 14.8823 60.4746 15.1294 60.4746 15.6235V45.1326C60.4746 47.6275 60.4746 48.875 60.1005 49.5162C59.7199 50.1685 59.3528 50.4717 58.6405 50.7224C57.9402 50.9688 56.5266 50.6972 53.6993 50.154C51.7205 49.7738 49.3735 49.4947 46.7474 49.4947C38.5111 49.4947 30.2748 54.9855 19.2931 54.9855C12.5703 54.9855 8.9342 53.9567 7.125 53.1586C6.88406 53.0523 6.7636 52.9992 6.4159 52.6674C6.20749 52.4685 5.82706 51.8849 5.72919 51.6139C5.56592 51.1619 5.56592 50.9148 5.56592 50.4206L5.56592 20.9116C5.56592 18.4166 5.56592 17.1691 5.94006 16.5279C6.32064 15.8756 6.68768 15.5724 7.40003 15.3217C8.10033 15.0753 9.51394 15.3469 12.3412 15.8901C14.3201 16.2704 16.667 16.5495 19.2931 16.5495C27.5294 16.5495 35.7657 11.0586 46.7474 11.0586ZM39.8838 33.0221C39.8838 36.8127 36.8109 39.8856 33.0203 39.8856C29.2296 39.8856 26.1567 36.8127 26.1567 33.0221C26.1567 29.2314 29.2296 26.1585 33.0203 26.1585C36.8109 26.1585 39.8838 29.2314 39.8838 33.0221Z"
                    stroke="white"
                    strokeWidth="5.49087"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            <h2 className={style.tituloOficina}>Bancos</h2>
          </div>
          <div className={style.contenedorcirculo}>
            <div className={style.circulo}>
              <div className={style.oficinas}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="56"
                  height="57"
                  viewBox="0 0 56 57"
                  fill="none"
                >
                  <path
                    d="M51.2512 24.1075H4.79004M25.6976 33.3997H14.0823M4.79004 19.926L4.79004 37.5812C4.79004 40.1833 4.79004 41.4843 5.29644 42.4782C5.74187 43.3524 6.45264 44.0632 7.32686 44.5086C8.32072 45.015 9.62176 45.015 12.2238 45.015L43.8174 45.015C46.4195 45.015 47.7205 45.015 48.7144 44.5086C49.5886 44.0632 50.2994 43.3524 50.7448 42.4782C51.2512 41.4843 51.2512 40.1833 51.2512 37.5812V19.926C51.2512 17.3239 51.2512 16.0229 50.7448 15.029C50.2994 14.1548 49.5886 13.444 48.7144 12.9986C47.7205 12.4922 46.4195 12.4922 43.8174 12.4922L12.2238 12.4922C9.62176 12.4922 8.32072 12.4922 7.32686 12.9986C6.45264 13.444 5.74188 14.1548 5.29644 15.029C4.79004 16.0229 4.79004 17.3239 4.79004 19.926Z"
                    stroke="white"
                    strokeWidth="4.64612"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            <h2 className={style.tituloOficina}>Pago tarjeta en línea</h2>
          </div>
        </div>
        <div className={style.contenedorSaber}>
          <Link
            to="https://drive.google.com/file/d/1OW4OGcld5jkDd-PU9HjoJWV8S91kIgRC/view"
            target="_blank"
            className={style.saberMas}
            href={pdf}
            download="informacion-de-pago.pdf"
          >
            Saber más
          </Link>
        </div>
      </div>
      <h2 className={style.tienes}>¿Tienes preguntas?</h2>
      <div className={style.contenedorFrecuentes}>
        {dataFaq ? (
          dataFaq.map((item, index) => (
            <PreguntasDespliegue
              key={index}
              pregunta={item.pregunta}
              respuesta={item.respuesta}
              vineta={item.vineta}
              desplegada={index === preguntaDesplegada}
              cambiarDespliegue={() => cambiarDespliegue(index)}
            />
          ))
        ) : (
          <h2>Cargando....</h2>
        )}
      </div>
    </>
  );
};
